import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../assets/styles/loader.css";

const SmallLoader = ({ vendorColor, loadDuration, interactiveSofaLoading, setInteractiveSofaLoading, loaderBlockStyle }) => {

  useEffect(() => {
    // Start the timer only if visible is true
    if (interactiveSofaLoading && typeof loadDuration === "number" && loadDuration > 0) {
      const timer = setTimeout(() => {
        setInteractiveSofaLoading(false);
      }, loadDuration * 1000); // Convert seconds to milliseconds

      return () => clearTimeout(timer); // Cleanup timer on component unmount or on visible change
    }
  }, [interactiveSofaLoading, loadDuration]); // Re-run effect when visible or loadDuration changes

  return (

    <div className="flex justify-center flex-col gap-3 items-center absolute left-0 top-0 w-full h-full z-[1300]">
      <div className="loader--facebook">
        <div style={loaderBlockStyle}></div>
        <div style={loaderBlockStyle}></div>
        <div style={loaderBlockStyle}></div>
      </div>
    </div>
  );
};

SmallLoader.propTypes = {
  vendorColor: PropTypes.string.isRequired,
  loadDuration: PropTypes.number.isRequired,
};

export default SmallLoader;
